(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'TaskOutcome',
	};

	var form_id = 'taskoutcome-';

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		var task_id = $('#' + form_id + 'id').val();

		// change the task action
		$('#' + form_id + 'task_action').on('change', function onTaskActionChange(e)
		{
			var action           = $(this).val(),
			    recurrence_count = $('#' + form_id + 'delete_recurrence_series').data('recurrence-count');

			$('.outcome-due-date-field').addClass('hidden');
			$('.outcome-reason-field').addClass('hidden');
			$('.outcome-delete-recurrence').addClass('hidden');
			$('.outcome-delete-warning').addClass('hidden');
			$('.task-outcome-button').html('Save Task');

			switch (action) {
				case 'change_due_date':
					$('.outcome-reason-field').removeClass('hidden');
					$('.outcome-due-date-field').removeClass('hidden');
					$('#' + form_id + 'reason').attr('placeholder', 'Reason for due date change...');
					break;
				case 'mark_complete':
					$('.outcome-reason-field').removeClass('hidden');
					$('#' + form_id + 'reason').attr('placeholder', 'Add comment on task completion...');
					break;
				case 'delete_task':
					if (recurrence_count > 0) {
						$('.outcome-delete-recurrence').removeClass('hidden');
					}

					$('.outcome-delete-warning').removeClass('hidden');
					$('.task-outcome-button').html('Delete Task');
					break;
				default:
					// nothing to do here
			}
		});

		// click to change the due date to today
		$('.outcome-due-date-field .push-today').on('click', function pushToday(e)
		{
			var due_date = $('#' + form_id + 'due_date').data('DateTimePicker');

			e.preventDefault();

			due_date.date(moment().format('YYYY-MM-DD'));
		});

		// click to push the due date to tomorrow
		$('.outcome-due-date-field .push-tomorrow').on('click', function pushTomorrow(e)
		{
			var due_date = $('#' + form_id + 'due_date').data('DateTimePicker');

			e.preventDefault();

			due_date.date(moment().add(1, 'days').format('YYYY-MM-DD'));
		});

		// click to push the due date 7 days
		$('.outcome-due-date-field .push-week').on('click', function pushWeek(e)
		{
			var due_date = $('#' + form_id + 'due_date').data('DateTimePicker');

			e.preventDefault();

			due_date.date(moment().add(7, 'days').format('YYYY-MM-DD'));
		});

		// click to mark the task as incomplete
		$('.outcome-mark-incomplete').on('click', function markIncomplete(e)
		{
			e.preventDefault();

			// this will flag it as incomplete if it's completed already
			Adzuki.Ajax.get('/Tasks/complete/' + task_id)
				.then(function completeTask(response) {
					_renderTaskOutcomeView(task_id);
					_renderTaskDetailsView(task_id);
					$('#task-details-nav').data('changed', 1);
				}
			);
		});

		$('#' + form_id + 'task_action').trigger('change');
	};

	form.success = function success(response)
	{
		var task_id          = $('#' + form_id + 'id').val(),
		    task_outcome     = $('#' + form_id + 'task_action').val(),
		    $success_message = 'The task outcome has been updated.';

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		if (task_outcome === 'delete_task') {
			$success_message = 'The task has been deleted.';
		}

		// show success message and re-render the form in the modal on success
		Adzuki.StatusMessage('success', $success_message, 'Success', {
			onClose: function onAlertClosed() {
				_renderTaskAttachmentsView(task_id);
				_renderTaskCommentsView(task_id);
				_renderTaskDetailsView(task_id);
				_renderTaskHistoryView(task_id);
				_renderTaskOutcomeView(task_id);

				// render these views only on delete to display "deleted task" message
				if (task_outcome === 'delete_task') {
					_renderTaskListView(task_id);
					_renderTaskReferenceView(task_id);
				}
			}
		});
	};

	function _renderTaskAttachmentsView(task_id)
	{
		var $modal = $('.modal');

		// render attachments view
		Adzuki.Ajax.get('/Tasks/viewTaskAttachments/' + task_id)
			.then(function viewTaskAttachments(response) {
				$modal.find('#task-attachments').html(response);

				Adzuki.Form.initAjaxForm('TaskAttachmentAdd');
			});

		// update the amount of attachments
		Adzuki.Ajax.get('/Tasks/getAttachmentsCount/' + task_id)
			.then(function getAttachmentsCount(response) {
				$('.task-attachments-count').addClass('hidden');

				if (response && response.attachments_count > 0) {
					$('.task-attachments-count')
					.removeClass('hidden')
					.text(response.attachments_count);
				}
			});
	}

	function _renderTaskCommentsView(task_id)
	{
		var $modal = $('.modal');

		// render comments view
		Adzuki.Ajax.get('/Tasks/viewTaskComments/' + task_id)
			.then(function viewTaskComments(response) {
				$modal.find('#task-comments').html(response);

				Adzuki.Form.initAjaxForm('TaskCommentAddEdit');
			});

		// update the amount of comments
		Adzuki.Ajax.get('/Tasks/getCommentsCount/' + task_id)
			.then(function getCommentsCount(response) {
				$('.task-comments-count').addClass('hidden');

				if (response && response.comments_count > 0) {
					$('.task-comments-count')
					.removeClass('hidden')
					.text(response.comments_count);
				}
			});
	}

	function _renderTaskDetailsView(task_id)
	{
		var $modal = $('.modal');

		Adzuki.Ajax.get('/Tasks/viewTaskDetails/' + task_id)
			.then(function viewTaskDetails(response) {
				$modal.find('#task-details').html(response);

				Adzuki.Form.initAjaxForm('TaskAddEdit');
			});
	}

	function _renderTaskHistoryView(task_id)
	{
		var $modal = $('.modal');

		Adzuki.Ajax.get('/Tasks/viewTaskHistory/' + task_id)
			.then(function viewTaskHistory(response) {
				$modal.find('#task-history').html(response);
			});
	}

	function _renderTaskListView(task_id)
	{
		var $modal = $('.modal');

		Adzuki.Ajax.get('/Tasks/viewTaskTaskList/' + task_id)
			.then(function viewTaskTaskList(response) {
				$modal.find('#task-task-list').html(response);
			});
	}

	function _renderTaskOutcomeView(task_id)
	{
		var $modal = $('.modal');

		// render task outcome view
		Adzuki.Ajax.get('/Tasks/viewTaskOutcome/' + task_id)
			.then(function viewTaskOutcome(response) {
				$modal.find('#task-outcome').html(response);
				$('#task-details-nav').data('changed', 1);

				Adzuki.Form.initAjaxForm('TaskOutcome');
			});
	}

	function _renderTaskReferenceView(task_id)
	{
		var $modal = $('.modal');

		Adzuki.Ajax.get('/Tasks/viewTaskReference/' + task_id)
			.then(function viewTaskReference(response) {
				$modal.find('#task-reference').html(response);
			});
	}
}(jQuery, window.Adzuki || {}));
